import { Warehouse as ApiWarehouse } from "randmar-api-client";
import { Building2, Mail, MapPin, Phone, User } from "lucide-react";
import React from "react";
import { Card } from "randmarcomps";

interface IProps {
  warehouse: ApiWarehouse;
}

const WarehouseInfoCard: React.FC<IProps> = ({ warehouse }) => {
  const cityProvince = [warehouse.City, warehouse.Province].filter(Boolean).join(", ");

  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border">
      <div className="flex flex-col sm:flex-row items-start justify-between gap-6 sm:gap-4">
        <div className="flex flex-row items-center space-x-4">
          <div className="bg-slate-100 rounded-full p-3 border">
            <Building2 className="h-8 w-8 text-slate-600" />
          </div>
          <div>
            {warehouse.Name && <h3 className="text-lg font-medium text-black">
              {warehouse.Name}
            </h3>}
            {warehouse.Country && <p className="whitespace-nowrap text-base text-slate-500">
              {warehouse.Country}
            </p>}
          </div>
        </div>
        <div className="space-y-1">
          {warehouse.ContactName && <h3 className="flex items-center gap-2 text-lg font-medium text-black">
            <User className="h-5 w-5 text-slate-400" />
            <span>{warehouse.ContactName}</span>
          </h3>}
          {warehouse.ContactEmail && <p className="flex items-center gap-2 whitespace-nowrap text-base text-slate-500">
            <Mail className="h-4 w-4" />
            <span>{warehouse.ContactEmail}</span>
          </p>}
          {warehouse.ContactPhone && <p className="flex items-center gap-2 whitespace-nowrap text-base text-slate-500">
            <Phone className="h-4 w-4" />
            <span>{warehouse.ContactPhone}</span>
          </p>}
        </div>
        <div className="space-y-1">
          {warehouse.Address1 && <h3 className="flex items-center gap-2 text-lg font-medium text-black">
            <MapPin className="h-5 w-5 text-slate-400" />
            <span>{warehouse.Address1}</span>
          </h3>}
          {warehouse.Address2 && <p className="pl-7 whitespace-nowrap text-base text-slate-500">
            {warehouse.Address2}
          </p>}
          {cityProvince && <p className="pl-7 whitespace-nowrap text-base text-slate-500">
            {cityProvince}
          </p>}
          {warehouse.PostalCode && <p className="pl-7 whitespace-nowrap text-base text-slate-500">
            {warehouse.PostalCode}
          </p>}
        </div>
      </div>
    </Card>
  );
}

export default WarehouseInfoCard;
